

import config from 'config';
import AssetsManager from 'js/components/AssetsManager';
import GameManager from 'js/components/GameManager';
import tools from 'tools';
import "./style/app.scss";

const loadingScreen = document.querySelector(".loading-screen");

export default class Main {

  constructor() {

    tools.autobind(this);

    this.initSdk = false;
    this.loaded = false;
    this.userDataReady = false

    GameManager.H5SDK.addEventListener("reconnected", (notif) => {
      const payload = notif.getPayload();
      const reconnected = payload.reconnected;


      if (reconnected) {

        if (config.resetProfilesDelayCall) {
          config.resetProfilesDelayCall.kill();
        }

        GameManager.pixiManager.header.initPlayers(() => {
          console.log("ready to change challenger");
          // GameManager.pixiManager.changeChallenger();
        });

      }

      config.reconnected = reconnected;

      console.log("reconnected:", config.reconnected);

    });



    GameManager.H5SDK.addEventListener('onLoadingStart', this.loadingGameHandler, 1);
    GameManager.H5SDK.addEventListener('onUserData', this.onUserDataReady, 1);
    GameManager.H5SDK.addEventListener('onPlatformInit', this.onPlatformInit, 1);
    GameManager.H5SDK.addEventListener("onConfigData"   ,  this.onConfigDataHandler );

    GameManager.H5SDK.getPlatform().init();


    this.init();


  }


  onPlatformInit() {

    GameManager.H5SDK.addEventListener('pause', this.pause);
    GameManager.H5SDK.addEventListener('resume', this.resume);
    window.addEventListener("resize", this.resize);

    // this.init();

  };


  async loadingGameHandler() {

    console.log("loadingGameHandler");

    this.initSdk = true;
    this.onInitAndLoadingHandler();

  }




  init() {

    AssetsManager.addEventListener("onProgress", e => {
      console.log(e.progress + "%");
      GameManager.H5SDK.getPlatform().notifyLoadingProgress(e.progress, true);
    });

    AssetsManager.addEventListener("ready", async () => {

      this.globalAssetsTime = tools.timeToSec(new Date().getTime() - this.globalAssetsTime);
      console.log("inGame_globalAssets:", this.globalAssetsTime);
      GameManager.H5SDK.getAnalyticsModule().onCustomEvent("inGame_globalAssets", this.globalAssetsTime);
      console.log("GameManager.H5SDK.getPlatform().getPlayerInfo():", GameManager.H5SDK.getPlatform().getPlayerInfo());

      this.loaded = true;

      this.onInitAndLoadingHandler();

    });


    //START
    this.globalAssetsTime = new Date().getTime();
    this.notifyLoadingCompleteTime = new Date().getTime();
    // console.log("StartLoading");
    AssetsManager.load();

  }



  async onInitAndLoadingHandler() {

    if (this.initSdk === true && this.loaded === true && this.userDataReady === true) {

      // config.savedData = await GameManager.H5SDK.getStoreModule().get(["coin", "currentSkin", "purchasedSkins", "dailyChallengeData", "arrowBooster", "shieldBooster"]);
      // config.bestScore = await GameManager.H5SDK.getScoreModule().getBestScore();

      console.log("100%");
      GameManager.H5SDK.getPlatform().notifyLoadingProgress("100", true);
      GameManager.H5SDK.getPlatform().notifyLoadingComplete();
      loadingScreen.classList.add("hidden");
      GameManager.setup();
      GameManager.setDatas();
      this.resize();
    }


  }


  async onUserDataReady() {

    //setTimeout(async () => {

      console.log("onUserDataReady")

      config.savedData = await GameManager.H5SDK.getStoreModule().get(["coin", "currentSkin", "purchasedSkins", "dailyChallengeData", "arrowBooster", "shieldBooster"]);
      config.bestScore = await GameManager.H5SDK.getScoreModule().getBestScore();
      // GameManager.H5SDK.getPlatform().triggerAfterComplete();
      this.userDataReady = true;
      this.onInitAndLoadingHandler();

   // }, 500);

  }


  resize() {
    GameManager.resize();
  };

  pause() {
    GameManager.pause();
  };

  resume() {
    GameManager.resume();
  };







}

//Launch
new Main();